
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type AddConversationMessage200LastMessageRole = typeof AddConversationMessage200LastMessageRole[keyof typeof AddConversationMessage200LastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddConversationMessage200LastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
